export { default } from "./rate"
